var map = {
	"./en": [
		763,
		167
	],
	"./en.js": [
		763,
		167
	],
	"./es": [
		764,
		799
	],
	"./es.js": [
		764,
		799
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 654;
module.exports = webpackAsyncContext;